var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
var widgetState = {
    data: null,
    error: null,
    loading: false
};
var defaultTemplateState = {
    data: null,
    error: null,
    loading: false
};
var userTemplateState = {
    data: null,
    error: null,
    loading: false
};
var updateTemplateState = {
    data: null,
    error: null,
    loading: false
};
var mediaState = {
    data: null,
    error: null,
    loading: false
};
var widgetDetailsState = {
    data: null,
    error: null,
    loading: false
};
var widgetCalendarState = {
    data: null,
    error: null,
    loading: false
};
var widgetDataState = {
    data: null,
    error: null,
    loading: false
};
var currentCacheWDState = {
    watchLogOut: false,
};
var widgetReducer = function (state, action) {
    if (state === void 0) { state = widgetState; }
    switch (action.type) {
        case Types.GET_WIDGET_LIST_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_WIDGET_LIST_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_WIDGET_LIST_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_WIDGET_LIST_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var defaultTemplateReducer = function (state, action) {
    if (state === void 0) { state = defaultTemplateState; }
    switch (action.type) {
        case Types.GET_TEMPLATE_PUBLISHER_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_TEMPLATE_PUBLISHER_SUCCES:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_TEMPLATE_PUBLISHER_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_TEMPLATE_PUBLISHER_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var userTemplateReducer = function (state, action) {
    if (state === void 0) { state = userTemplateState; }
    switch (action.type) {
        case Types.GET_TEMPLATE_USER_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_TEMPLATE_USER_SUCCES:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_TEMPLATE_USER_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_TEMPLATE_USER_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var updateTemplateReducer = function (state, action) {
    if (state === void 0) { state = updateTemplateState; }
    switch (action.type) {
        case Types.UPDATE_TEMPLATE_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.UPDATE_TEMPLATE_SUCCES:
            return __assign(__assign({}, state), { data: action.data });
        case Types.UPDATE_TEMPLATE_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.UPDATE_TEMPLATE_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var updateUserTemplateReducer = function (state, action) {
    if (state === void 0) { state = updateTemplateState; }
    switch (action.type) {
        case Types.UPDATE_USER_TEMPLATE_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.UPDATE_USER_TEMPLATE_SUCCES:
            return __assign(__assign({}, state), { data: action.data });
        case Types.UPDATE_USER_TEMPLATE_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.UPDATE_USER_TEMPLATE_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var mediaReducer = function (state, action) {
    if (state === void 0) { state = mediaState; }
    switch (action.type) {
        case Types.GET_MEDIA_LIST_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_MEDIA_LIST_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_MEDIA_LIST_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_MEDIA_LIST_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var widgetDetailsReducer = function (state, action) {
    if (state === void 0) { state = widgetDetailsState; }
    switch (action.type) {
        case Types.GET_WIDGET_DETAILS_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_WIDGET_DETAILS_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_WIDGET_DETAILS_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_WIDGET_DETAILS_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var widgetCalendarReducer = function (state, action) {
    if (state === void 0) { state = widgetCalendarState; }
    switch (action.type) {
        case Types.GET_WIDGET_CALENDAR_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_WIDGET_CALENDAR_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_WIDGET_CALENDAR_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_WIDGET_CALENDAR_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var widgetDataReducer = function (state, action) {
    if (state === void 0) { state = widgetDataState; }
    switch (action.type) {
        case Types.GET_WIDGET_DATA_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_WIDGET_DATA_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_WIDGET_DATA_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_WIDGET_DATA_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var cacheWDSumaryReducer = function (state, action) {
    if (state === void 0) { state = currentCacheWDState; }
    switch (action.type) {
        case Types.LOADING_INTERVAL_WD_SUMARY:
            return __assign(__assign({}, state), { watchLogOut: action.watchLogOut });
        default:
            return state;
    }
};
var cacheWDTop3RateIncreaseReducer = function (state, action) {
    if (state === void 0) { state = currentCacheWDState; }
    switch (action.type) {
        case Types.LOADING_INTERVAL_WD_TOP3_RATE_INCREASE:
            return __assign(__assign({}, state), { watchLogOut: action.watchLogOut });
        default:
            return state;
    }
};
var cacheWDTop3RateDecreaseReducer = function (state, action) {
    if (state === void 0) { state = currentCacheWDState; }
    switch (action.type) {
        case Types.LOADING_INTERVAL_WD_TOP3_RATE_DECREASE:
            return __assign(__assign({}, state), { watchLogOut: action.watchLogOut });
        default:
            return state;
    }
};
var WidgetReducer = {
    defaultTemplateData: defaultTemplateReducer,
    widgetData: widgetReducer,
    userTemplateData: userTemplateReducer,
    updateTemplateData: updateTemplateReducer,
    updateUserTemplateData: updateUserTemplateReducer,
    mediaData: mediaReducer,
    widgetDetailsData: widgetDetailsReducer,
    widgetCalendarData: widgetCalendarReducer,
    widgetDataOrigin: widgetDataReducer,
    cacheWDSumaryData: cacheWDSumaryReducer,
    cacheWDTop3RateIncreaseData: cacheWDTop3RateIncreaseReducer,
    cacheWDTop3RateDecreaseData: cacheWDTop3RateDecreaseReducer
};
export var widgetData = function (state) { return (state.widgetData.data ? state.widgetData.data : null); };
export var widgetError = function (state) { return state.widgetData.error; };
export var isLoadingWidget = function (state) { return state.widgetData.loading; };
export var defaultTemplateData = function (state) { return (state.defaultTemplateData.data ? state.defaultTemplateData.data : null); };
export var defaultTemplateError = function (state) { return state.defaultTemplateData.error; };
export var isLoadingDefaultTemplate = function (state) { return state.defaultTemplateData.loading; };
export var userTemplateData = function (state) { return (state.userTemplateData.data ? state.userTemplateData.data : null); };
export var userTemplateError = function (state) { return state.userTemplateData.error; };
export var isLoadingUserTemplate = function (state) { return state.userTemplateData.loading; };
export var updateTemplateData = function (state) { return (state.updateTemplateData.data ? state.updateTemplateData.data : null); };
export var updateTemplateError = function (state) { return state.updateTemplateData.error; };
export var isUpdatingTemplate = function (state) { return state.updateTemplateData.loading; };
export var updateUserTemplateData = function (state) { return (state.updateUserTemplateData.data ? state.updateUserTemplateData.data : null); };
export var updateUserTemplateError = function (state) { return state.updateUserTemplateData.error; };
export var isUpdatingUserTemplate = function (state) { return state.updateUserTemplateData.loading; };
export var mediaData = function (state) { return (state.mediaData.data ? state.mediaData.data : null); };
export var mediaError = function (state) { return state.mediaData.error; };
export var isLoadingMedia = function (state) { return state.mediaData.loading; };
export var widgetDetailsData = function (state) { return (state.widgetDetailsData.data ? state.widgetDetailsData.data : null); };
export var widgetDetailsError = function (state) { return state.widgetDetailsData.error; };
export var isLoadingWidgetDetails = function (state) { return state.widgetDetailsData.loading; };
export var widgetCalendarData = function (state) { return (state.widgetCalendarData.data ? state.widgetCalendarData.data : null); };
export var widgetCalendarError = function (state) { return state.widgetCalendarData.error; };
export var isLoadingWidgetCalendar = function (state) { return state.widgetCalendarData.loading; };
export var widgetDataOrigin = function (state) { return (state.widgetDataOrigin.data ? state.widgetDataOrigin.data : null); };
export var widgetDataOriginError = function (state) { return state.widgetDataOrigin.error; };
export var isLoadingWidgetDataOrigin = function (state) { return state.widgetDataOrigin.loading; };
export var getCacheWDSummary = function (state) { return (state.cacheWDSumaryData.watchLogOut || false); };
export var getCacheWDTop3RateIncrease = function (state) { return (state.cacheWDTop3RateIncreaseData.watchLogOut || false); };
export var getCacheWDTop3RateDecrease = function (state) { return (state.cacheWDTop3RateDecreaseData.watchLogOut || false); };
export default WidgetReducer;
